/**
 * Configuración declarativa de los menús laterales (§5.2-5.4 SRS).
 *
 * Cada item: { label, path, icon }. El icono es un caracter Unicode por simplicidad — en milestone
 * de UI fina podemos cambiar a Lucide/Heroicons.
 */

export type NavItem = {
  label: string
  path: string
  icon: string
}

export type NavConfig = {
  /** Zona principal (§5.2) — navegación primaria. */
  primary: NavItem[]
  /** Zona media (§5.3) — accesos directos fijos. */
  middle: NavItem[]
}

// ─── Portal de usuario ─────────────────────────────────────────────────────
export const USER_NAV: NavConfig = {
  primary: [
    { label: 'Dashboard', path: '/dashboard', icon: '📊' },
    { label: 'Reportes', path: '/reportes', icon: '📋' },
    { label: 'Clientes', path: '/clientes', icon: '👥' },
  ],
  middle: [],
}

/** Ítems adicionales visibles solo para role='owner'. Se inyectan en AppShell condicionalmente. */
export const EMPRESA_NAV_ITEM: NavItem = {
  label: 'Empresa',
  path: '/empresa',
  icon: '🏢',
}

export const SUSCRIPCION_NAV_ITEM: NavItem = {
  label: 'Suscripción',
  path: '/suscripcion',
  icon: '💎',
}

// ─── Portal de administrador (§12.2) ──────────────────────────────────────
export const ADMIN_NAV: NavConfig = {
  primary: [
    { label: 'Dashboard', path: '/admin', icon: '📊' },
    { label: 'Mensajes Broadcast', path: '/admin/broadcast', icon: '📢' },
    { label: 'Usuarios', path: '/admin/usuarios', icon: '👥' },
    { label: 'Finanzas', path: '/admin/finanzas', icon: '💰' },
    { label: 'Planes', path: '/admin/planes', icon: '💳' },
    { label: 'Legal', path: '/admin/legal', icon: '⚖️' },
    { label: 'Configuración', path: '/admin/server-config', icon: '⚙️' },
  ],
  middle: [],
}
